import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { Auth } from '../../containers/Auth';
import './styles.css';

export const Home = () => {
  const { user, logout } = useAuth();

  const handleLogout = async () => {
    try {
      await logout();
    } catch (error) {
      console.error('Failed to log out:', error);
    }
  };

  if (!user) {
    return <Auth />;
  }

  return (
    <div className="home-page">
      <div className="user-header">
        <h2>Welcome, {user.email}!</h2>
        <button onClick={handleLogout} className="logout-button">
          Log Out
        </button>
      </div>
      
      <div className="content">
        <h3>Your Setlist Selection</h3>
        {/* Setlist content will go here */}
      </div>
    </div>
  );
// };om 'react';
// import CheckboxList from '../../components/CheckboxList';
// import './styles.css';

// export const Home = () => {
//   return (
//     <div className="home-page">
//       <h2>Pick your setlist!</h2>
//       <div className="checkbox-section">
//         <h3>Your favorites</h3>
//         <CheckboxList />
//       </div>
//     </div>
//   );
};
